module.exports = __webpack_public_path__ + "static/media/noclass7.10ce3dab.png";